document.addEventListener('alpine:init', () => {
  function productFormLines(data = {}) {
    var linesEnabledAmountDefault = Object.keys(data.lines).reduce((acc, key) => {
      if (data.lines[key]) acc += 1;

      return acc;
    }, 0);

    return {
      ...data,

      linesEnabledAmount: linesEnabledAmountDefault || 2,
      
      incrementLinesEnabledAmount() {
        this.linesEnabledAmount += 1;
      },

      getLineEnabledState(index) {
        return this.linesEnabledAmount >= index || this.lines[`Line ${index}`];
      }
    };
  };

  Alpine.data('productFormLines', productFormLines);
});
